
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const FETCH_LANGUAGE_REQUEST = 'FETCH_LANGUAGE_REQUEST';
export const FETCH_LANGUAGE_SUCCESS = 'FETCH_LANGUAGE_SUCCESS';
export const FETCH_LANGUAGE_ERROR = 'FETCH_LANGUAGE_ERROR';

export const setLanguage = (language) => ({
  type: SET_LANGUAGE,
  payload: language,
});

export const fetchLanguageRequest = () => ({
  type: FETCH_LANGUAGE_REQUEST,
});

export const fetchLanguageSuccess = (languages) => ({
  type: FETCH_LANGUAGE_SUCCESS,
  payload: languages,
});

export const fetchLanguageError = (error) => ({
  type: FETCH_LANGUAGE_ERROR,
  payload: error,
});
